<template>
  <responsive-drawer-layout>
    <template v-slot:drawer v-if="isWebLinkGroup">
      <div v-if="!instanceWebLinks" class="pa-8">
        <h3>{{ $t('weblinks.noLinks') }}</h3>
      </div>
      <template v-for="item in instanceWebLinks">
        <weblink-item
          :item="item"
          @onOpenInternally="openInternally(item)"
          @onOpenExternally="openExternally(item)"
          :key="item.id"
          :isSelected="isSelected(item)"
        ></weblink-item>
        <v-divider :key="item.id + '_'"></v-divider>
      </template>
    </template>

    <template v-slot:content>
      <v-dialog v-model="dialog" width="500">
        <template v-slot:activator="{ on, attrs }">
          <v-btn style="display: none" dark v-bind="attrs" v-on="on"></v-btn>
        </template>

        <v-card>
          <v-card-title class="headline">
            {{ $t('weblinks.externalLink') }}
            <v-spacer></v-spacer>
            <v-btn icon @click="closeDialog()">
              <v-icon color="white">mdi-close</v-icon>
            </v-btn>
          </v-card-title>

          <v-card-text style="padding-top: 15px; min-height: 200px">
            <p>{{ $t('weblinks.youAreLeavingTheAppAndOpen') }}</p>
            {{ getWeblinkUrl(currentWeblinkItem) }}
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              :class="`${theme.elements.btnColor}`"
              text
              @click="
                abort();
                dialog = false;
              "
            >
              {{ $t('weblinks.abort') }}
            </v-btn>

            <v-btn
              :class="`${theme.elements.btnColor}`"
              text
              @click="
                openWebLinkExternally(currentWeblinkItem);
                dialog = false;
              "
            >
              {{ $t('weblinks.ok') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <div v-if="currentWeblinkItem && openInIframe" class="inherit-height background">
        <iframe
          v-if="currentWeblinkItemIsYoutube"
          id="weblinkFrame"
          :src="currentWeblinkItemUrl"
          width="100%"
          class="background"
          style="height: inherit"
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        ></iframe>

        <iframe v-else id="weblinkFrame" :src="currentWeblinkItemUrl" width="100%" class="background" style="height: inherit"></iframe>
      </div>
      <div v-else class="d-flex inherit-height justify-center align-center">
        <div v-if="currentWeblinkItem" v-html="$t('openedInNewTab', { url: currentWeblinkItemUrl })"></div>
        <!-- <info-card :textRows="['No items']"></info-card> -->
        <v-icon v-else size="300" :color="darkMode ? '#151515' : '#f0f0f0'">mdi-web</v-icon>
      </div>
    </template>
  </responsive-drawer-layout>
</template>

<script>
import common from '@/mixins/common';
import configMixin from '@/mixins/configMixin';
import dateTimeMixin from '@/mixins/dateTimeMixin';
import ResponsiveDrawerLayout from '@/layouts/ResponsiveDrawerLayout';
import WeblinkItem from './WeblinkItem';
import index from './index';
import MODULE_ID from './moduleId';
import { mapState } from 'vuex';
import weblinkService from '@/modules/weblinks/weblinkService';
import weblinkApi from '@/modules/weblinks/weblinkApi';

export default {
  name: 'Weblinks',
  mixins: [common, configMixin, dateTimeMixin],
  components: {
    WeblinkItem,
    ResponsiveDrawerLayout,
  },

  mounted() {
    this.init();

    // if (this.currentWeblinkItem && !this.openInIframe) {
    //   try {
    //     window.open(this.currentWeblinkItem.url, '_blank', 'fullscreen=yes'); // Opens a new windowmyWindow = window.open("", "myWindow", "width=200,height=100");   // Opens a new window
    //   } catch (err) {
    //     console.debug('Failed to open in a _self window, try with _blank');
    //     window.open(this.currentWeblinkItem.url, '_blank', 'fullscreen=yes'); // Opens a new windowmyWindow = window.open("", "myWindow", "width=200,height=100");   // Opens a new window
    //   }
    // }
  },
  data() {
    return {
      dialog: false,
      currentWeblinkItem: null,
    };
  },
  computed: {
    ...mapState(MODULE_ID, ['dataLoaded', 'weblinkItems']),
    instanceWebLinks() {
      return this.weblinkItems.filter((item) => item.instance === this.instance);
    },
    currentWeblinkItemUrl() {
      let item = this.currentWeblinkItem;
      let url = this.getWeblinkUrl(this.currentWeblinkItem);
      if (item) {
        return url;
      }
      return null;
    },
    currentWeblinkItemIsYoutube() {
      if (this.currentWeblinkItemUrl) {
        return this.currentWeblinkItemUrl.includes('www.youtube.com') || this.currentWeblinkItemUrl.includes('https://youtu.be/');
      }
      return false;
    },
    openInIframe() {
      return this.currentWeblinkItem ? this.currentWeblinkItem.intern === 1 && this.currentWeblinkItemIsYoutube : false;
      //return this.moduleConfig ? this.moduleConfig.openInIframe : false;
    },

    color() {
      return this.theme.appBar.other.color;
    },

    instance() {
      return Number(this.$route.params.instance);
    },
    moduleConfig() {
      return this.getModuleConfig(index.moduleType, this.$route.params.instance); //mixin
    },
    isWebLinkGroup() {
      return this.moduleConfig && this.moduleConfig.isWebLinkGroup;
    },
  },
  methods: {
    init() {
      if (!this.isWebLinkGroup) {
        this.currentWeblinkItem = this.weblinkItems.find((i) => i.instance === this.instance);
        console.debug('open webLink no webLinkGroup', this.currentWeblinkItem);

        this.$nextTick(() => {
          if (this.openInIframe) {
            console.debug('open webLink no webLinkGroup', this.currentWeblinkItemUrl);
            window.open(this.currentWeblinkItemUrl, '_blank');
          }
        });
      } else {
        this.mx_isLeftDrawerOpen = true;
      }
    },
    async getSsoToken() {
      const response = await weblinkApi.getSSOToken();
      return response && response.data && response.data.token ? response.data.token : '';
    },
    isSelected(item) {
      return this.currentWeblinkItem && this.currentWeblinkItem.id === item.id;
    },
    getWeblinkUrl(weblink) {
      return weblinkService.getWeblinkUrl(weblink);
    },
    abort() {
      this.closeDialog();
      this.currentWeblinkItem = null;
      this.mx_isLeftDrawerOpen = true;
    },
    closeDialog() {
      this.dialog = false;
    },

    openInternally(item) {
      console.debug('openInternally', item.title, item.url);
      this.currentWeblinkItem = item;
      this.$store.commit('weblinks/setCurrentWeblink', item);

      this.mx_isLeftDrawerOpen = false;
    },
    openExternally(item) {
      this.currentWeblinkItem = item;
      this.$store.commit('weblinks/setCurrentWeblink', item);
      console.debug('onOpenExternally', item.url);
      if (item.showMessage) {
        // open externally, but await dialog
        this.dialog = true;
      } else {
        this.openWebLinkExternally(item);
      }
    },
    async openWebLinkExternally(item) {
      this.currentWeblinkItem = item;
      let target = '_blank';
      let modifiedUrl = this.getWeblinkUrl(item);
      console.debug('openExternalUrl', modifiedUrl, target);
      this.mx_isLeftDrawerOpen = false;

      if (item && item.url && item.sendAuthentication) {
        const ssoToken = await this.getSsoToken();
        if (ssoToken) {
          let mod = modifiedUrl.indexOf('?') > -1 ? '&' : '?';
          modifiedUrl += `${mod}token=${ssoToken}`;
          //console.debug('weblink url', modifiedUrl);
        }
      }

      if (item.intern === 1) {
        window.open(modifiedUrl, '_blank', 'fullscreen=yes').focus();
      } else {
        window.open(modifiedUrl, '_blank').focus();
      }
    },
    onOpen(item) {
      this.openItem(item, item.intern === 1);
    },
  },
  watch: {
    currentWeblinkItemIsOpenedInternally(newValue, oldValue) {
      if (newValue === true) {
        this.mx_isLeftDrawerOpen = false;
      }
    },
    $route(newValue, oldValue) {
      this.init();
    },
  },
};
</script>
